import { render, staticRenderFns } from "./cs-CH.vue?vue&type=template&id=16b11dde&scoped=true&"
var script = {}
import style0 from "./cs-CH.vue?vue&type=style&index=0&id=16b11dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b11dde",
  null
  
)

export default component.exports